export default __webpack_public_path__ + "static/media/Logo.cb6a7c97.svg";